// extracted by mini-css-extract-plugin
export var core = "_404-module--core--kz0Cb";